var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headbar",style:({
        background: _vm.backgroundColor,
        height: (_vm.text == '来程订票' || _vm.text == '返程订票') && _vm.isAdd ? '3rem' : '2.63rem'
    })},[_c('div',{staticClass:"header-item"},[_c('div',{staticClass:"headbar-left"},[_c('span',{staticClass:"cricle"}),_c('span',[_vm._v(_vm._s(_vm.text))])]),((_vm.text == '来程订票' || _vm.text == '返程订票') && _vm.isAdd)?_c('div',{staticClass:"headbar-right",on:{"click":_vm.handleAdd}},[_c('span',{class:{ disabled: _vm.disabled }},[_vm._v("行程收集")])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }